module.exports = __webpack_public_path__ + "static/media/han_com_whi_che.8df3e162.png";